import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhotoSlideShowComponent } from './photo-slide-show/photo-slide-show.component';
import { SharedModule } from 'projects/shared/src/app/shared.module';
import { DatePickerBootstrapComponent } from 'projects/shared/src/app/pmkvy-shared/date-picker-bootstrap/date-picker-bootstrap.component';
import { TimePickerBootstrapComponent } from 'projects/shared/src/app/pmkvy-shared/time-picker-bootstrap/time-picker-bootstrap.component';
import { NgbDateCustomParserFormatterService } from 'projects/services/src/app/NgbDateCustomParserFormatter.service';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule, // date & time picker
		IntlModule, // date & time picker
		DateInputsModule,// date & time picker,
		SharedModule,
	],
	declarations: [
		DatePickerBootstrapComponent,
		TimePickerBootstrapComponent,
		PhotoSlideShowComponent
	],
	exports: [
		DatePickerBootstrapComponent,
		TimePickerBootstrapComponent,
		PhotoSlideShowComponent
	],
	providers: [
		{ provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatterService },
	]
})
export class AngularWidgetModule {}
